/**
 * Shipping Protection cart hygiene.
 *
 * The Elixir cart drawer renders the protection toggle as "checked" whenever the
 * protection product is in the cart, so the toggle is purely the customer's own
 * opt-in. Nothing is added automatically. This only stops the cart from being
 * left in a nonsense state:
 *   - protection is the only thing left in the cart -> remove it
 */
(function () {
  var SP_VARIANT = '46123248615618'; // Shipping protection variant
  var busy = false;

  function cartRoute(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function refreshDrawer() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer || typeof updateCartDrawer !== 'function') return Promise.resolve();

    return fetch(cartRoute('cart_url', '/cart') + '?view=drawer')
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        var current = document.querySelector('#CartDrawer');
        if (current && fresh) updateCartDrawer(current, fresh, true, function () {});
      })
      .catch(function () {});
  }

  function markToggle(checked) {
    var label = document.querySelector('.gb-shipping-protection-button label.switch');
    var input = document.querySelector('.gb-shipping-protection-button label.switch input');
    if (!label) return;
    label.classList.toggle('checked', checked);
    label.classList.toggle('unchecked', !checked);
    if (input) input.checked = checked;
  }

  function syncProtection() {
    if (busy) return Promise.resolve();
    busy = true;

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var hasProtection = items.some(function (item) {
          return String(item.variant_id) === SP_VARIANT;
        });
        var hasOther = items.some(function (item) {
          return String(item.variant_id) !== SP_VARIANT;
        });

        // Don't leave a cart holding nothing but protection.
        if (hasProtection && !hasOther) {
          return fetch(cartRoute('cart_change_url', '/cart/change') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: SP_VARIANT, quantity: 0 })
          })
            .then(refreshDrawer)
            .then(function () {
              markToggle(false);
            });
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  }

  var pending = null;
  function scheduleSync(delay) {
    clearTimeout(pending);
    pending = setTimeout(syncProtection, delay || 250);
  }

  // Every cart mutation in this theme goes through fetch, so one wrapper covers
  // product pages, the drawer, upsells and bundles alike.
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch.apply(this, arguments);

    if (!busy && /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
      promise
        .then(function (response) {
          if (response && response.ok) scheduleSync(350);
        })
        .catch(function () {});
    }

    return promise;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSync(600);
    });
  } else {
    scheduleSync(600);
  }
})();
